// extracted by mini-css-extract-plugin
module.exports = {"svgPathAnim":"Hero-module--svgPathAnim--1kcbK","strokeOffset":"Hero-module--stroke-offset--JlRy2"};